export const TIMELINE_OBJECT = 'TIMELINE-OBJECT';
export const Types = {
  ASSETS: 'ASSETS',
  COLLECTION: 'COLLECTION',
  TIMELINE_OBJECT,
};
